import { FlowMetaData } from "../flow-meta-data";

import { NodeTypes } from "../../utils/nodeTypes";

export enum FlowModeState {
    PREVIEW_MODE = 'PREVIEW_MODE',
    FLOW_MODE = 'FLOW_MODE',
    API_FLOW_MODE = 'API_FLOW_MODE',
    SEARCH_MODE = 'SEARCH_MODE',
}

export interface Flow {
    flowModeState: FlowModeState;
    flowMetaData: FlowMetaData;
    nodeTypes: NodeTypes;
    permissions: any;
}

export enum FlowType {
    ApiFlow = 'API_FLOW',
    NestedFlow = 'NESTED_FLOW',
    ChatFlow = 'CHAT_FLOW'
}

export enum FlowDeployState {
    /*
        to be used for the single-approver enabled clients (1-step)
     */
    CLICK_DEPLOY = 1,
    /*
       to be used for a normal deploy to later approve process (2-step)
     */
    DEPLOY = 2
}

